import InvestorStructureEnum from '@constants/enums/investor/structure';
import UserStatusEnum from '@constants/enums/user/status';

import i18n from '@plugins/i18n';

import { Collection, Investor } from '@/models';

export class SystemInvestorsCollection extends Collection {
    static type = 'SystemInvestorsCollection';
    static endpoint = Investor.api.index;
    static model = Investor;

    get default_headers() {
        return ['name', 'email', 'status', 'gi_ref', 'fca_number', 'investor_structure'];
    }

    get headers() {
        return [
            this.createHeader('id', i18n.t('id'), {
                classList: ['no-wrap'],
                width: '20rem',
                filterable: {
                    operators: this.getOperators(['eq'])
                }
            }),
            this.createHeader('name', i18n.t('name'), {
                filterable: true,
                width: '18rem',
                minWidth: '18rem'
            }),
            this.createHeader('email', i18n.t('email'), {
                filterable: true,
                width: '18rem',
                minWidth: '18rem'
            }),
            this.createHeader('status', i18n.t('status'), {
                format: 'enum',
                filterable: true,
                width: '11rem',
                enum: UserStatusEnum,
                enumA11yKey: 'enums.user_status',
                enumTypes: {
                    [UserStatusEnum.ACTIVE]: 'success',
                    [UserStatusEnum.INACTIVE]: 'grey',
                    [UserStatusEnum.SUSPENDED]: 'error',
                    [UserStatusEnum.UNVERIFIED]: 'warning'
                }
            }),
            this.createHeader('gi_ref', i18n.t('gi_ref'), {
                filterable: true,
                width: '9rem'
            }),
            this.createHeader('fca_number', i18n.t('fca_number'), {
                filterable: true,
                width: '12rem'
            }),
            this.createHeader('investor_structure', i18n.t('investor_structure'), {
                format: 'enum',
                filterable: true,
                width: '11rem',
                enum: InvestorStructureEnum,
                enumA11yKey: 'enums.investor_structure'
            }),
            this.createHeader('investment_account_authorised_at', i18n.t('authorised_at'), {
                width: '9rem',
                filterable: true,
                format: 'datetime',
                active: false
            }),
            this.createHeader('control', '', {
                format: 'control',
                width: '7rem',
                persistent: true
            })
        ];
    }
}

export default SystemInvestorsCollection;
